import * as constants from './constants';

interface iOpenModalAction {
    type: constants.OPEN_MODAL_TYPE;
}

export const openModal = (): iOpenModalAction => ({
    type: constants.OPEN_MODAL,
});

interface iCloseModalAction {
    type: constants.CLOSE_MODAL_TYPE;
}

export const closeModal = (): iCloseModalAction => ({
    type: constants.CLOSE_MODAL,
});

export type HowToStartModalAction = iOpenModalAction | iCloseModalAction;
